import { MapRef } from '@vis.gl/react-maplibre';
import { createRef } from 'react';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { MapLayer } from '@/types/MapLayer';
import { MapState } from '@/types/MapState';
import { MapStyle } from '@/types/MapStyle';

export const useMapStore = create<MapState>()(
  persist(
    (set) => ({
      map: createRef<MapRef>(),

      style: MapStyle.VECTOR,

      layers: {
        [MapLayer.ATKIS_PATHS]: false,
        [MapLayer.ATKIS_STREETS]: false,
      },

      measuringActive: false,

      snackbar: undefined,

      measureFeatureCollection: {
        type: 'FeatureCollection',
        features: [],
      },

      selectedFeature: null,

      actions: {
        setStyle: (style) => set({ style }),
        toggleLayer: (layer) =>
          set(({ layers }) => ({
            layers: {
              ...layers,
              [layer]: !layers[layer],
            },
          })),
        toggleMeasuringActive: () => set(({ measuringActive }) => ({ measuringActive: !measuringActive })),
        setSnackbar: (snackbar) => set({ snackbar }),
        setMeasureFeatureCollection: (measureFeatureCollection) => set({ measureFeatureCollection }),
        setSelectedFeature: (selectedFeature) => set({ selectedFeature }),
      },
    }),
    {
      name: 'vzk-bw/map',
      version: 1,
      partialize: ({ actions, measureFeatureCollection, measuringActive, selectedFeature, snackbar, ...rest }) => rest,
    },
  ),
);
